import { render, staticRenderFns } from "./PhysicalModel.vue?vue&type=template&id=17c57998&scoped=true"
import script from "./PhysicalModel.vue?vue&type=script&lang=js"
export * from "./PhysicalModel.vue?vue&type=script&lang=js"
import style0 from "./PhysicalModel.vue?vue&type=style&index=0&id=17c57998&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_j7knk6mol3vthgvrc443rvn57u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c57998",
  null
  
)

export default component.exports